export const apiName: string = 'destinos-deslocamentos';
export const destinosRoute: string = 'destinos';
export const destinosStorage: string = 'destinos';
export const destinosModuleName: any = {plural: 'Destinos', single: 'Destino'};

export const destinosQuery: any = {
  "where":{
    "ativo":true,
    "destino":{"regexp":"/REPLACEHERE/i"}
  },
  "order":"destino"
};



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/viagens/destinos/shared/data.service.ts
 **/